import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalLibraryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_library"}/>
}
